var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 41,
    viewBox: "0 0 60 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32930_23417)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_32930_23417)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6216 14.2247V26.8195H48.2675C44.7584 26.8195 41.9136 24 41.9136 20.5221C41.9136 17.044 44.7584 14.2247 48.2675 14.2247H54.6216ZM51.4446 20.5221C51.4446 22.261 50.0222 23.6707 48.2675 23.6707C46.513 23.6707 45.0907 22.261 45.0907 20.5221C45.0907 18.7831 46.513 17.3733 48.2675 17.3733C50.0222 17.3733 51.4446 18.7831 51.4446 20.5221Z",
    fill: "url(#paint0_linear_32930_23417)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6216 26.8195H56.4483C58.0713 26.8195 59.387 25.5155 59.387 23.9069V17.1372C59.387 15.5286 58.0713 14.2247 56.4483 14.2247H54.6216V26.8195Z",
    fill: "url(#paint1_linear_32930_23417)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bii_32930_23417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.613022 8.79304C0.613022 3.96735 4.56012 0.0553284 9.42911 0.0553284H45.8053C50.6745 0.0553284 54.6216 3.96735 54.6216 8.79304V32.251C54.6216 37.0767 50.6745 40.9887 45.8055 40.9887H9.42911C4.56013 40.9887 0.613022 37.0767 0.613022 32.251V8.79304Z",
    fill: "url(#paint2_linear_32930_23417)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_32930_23417",
    x: 40.9136,
    y: 13.2247,
    width: 14.7079,
    height: 14.5948,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_32930_23417"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bii_32930_23417",
    x: -3.38698,
    y: -3.94467,
    width: 62.0086,
    height: 48.9334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_32930_23417"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_32930_23417",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.895833 0 0 0 0 0.895833 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_32930_23417"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.894118 0 0 0 0 0.894118 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_32930_23417",
    result: "effect3_innerShadow_32930_23417"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32930_23417",
    x1: 41.9136,
    y1: 20.5221,
    x2: 54.6216,
    y2: 20.5221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#FBCBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#C48A79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#945B3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32930_23417",
    x1: 54.6216,
    y1: 20.5221,
    x2: 59.387,
    y2: 20.5221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#FBCBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#C48A79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#945B3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32930_23417",
    x1: -24.0007,
    y1: 10.4496,
    x2: 67.8034,
    y2: 71.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104415,
    stopColor: "#313F67",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415705,
    stopColor: "#5389BB",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917188,
    stopColor: "#81C1E4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32930_23417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 41,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.a64419b3005e76edc9cc8191429dba39.svg";
export { ForwardRef as ReactComponent };